import { CalendarService } from 'src/app/services/calendar__/calendar.service';
import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';

import { CalendarOptions } from '@fullcalendar/core';
import type { EventApi } from '@fullcalendar/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import Swal from 'sweetalert2';

import { category, calendarEvents, createEventId } from './data';
import { ActivatedRoute, Router } from '@angular/router';
import * as dayjs from 'dayjs';
import { BlackoutdayService } from 'src/app/services/blackoutday/blackoutday.service';
import { CampaignsService } from 'src/app/services/campaigns/campaigns.service';
import { DomSanitizer } from '@angular/platform-browser';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import { FullCalendarComponent } from '@fullcalendar/angular';

@Component({
	selector: 'app-calendar',
	templateUrl: './calendar.component.html',
	styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
	breadCrumbItems!: Array<{}>;

	calendarEvents: any[] = [];
	editEvent: any;
	formEditData!: FormGroup;
	newEventDate: any;
	category!: any[];
	submitted = false;
	campaignInfo: any = {};
	campaignId!: number;
	@Input() showCalendar: boolean = true;

	formData!: FormGroup;
	@ViewChild('editmodalShow') editmodalShow!: TemplateRef<any>;
	@ViewChild('modalShow') modalShow!: TemplateRef<any>;
	@ViewChild('calendar') calendarComponent!: FullCalendarComponent;

	@Input() campaign_id: number;
	@Input() alias: string;
	campaign_name: string;
	@Input() isPadre: boolean = false;

	campaignLoading: boolean = false;
	campaignMsg: string = '';
	eventCountByDate: { [date: string]: number } = {};

	constructor(
		private modalService: NgbModal,
		private formBuilder: FormBuilder,
		private route: ActivatedRoute,
		private calendarSrv: CalendarService,
		private bodSrv: BlackoutdayService,
		private campaignSrv: CampaignsService,
		private sanitizer: DomSanitizer,
		private router: Router,
	) {}

	ngOnInit(): void {
		if (this.isPadre) {
			if (!this.campaign_id) {
				this.campaign_id = parseInt(this.route.snapshot.paramMap.get('campaign_id') || '0');
			}
			if (!this.alias) {
				this.alias = this.route.snapshot.paramMap.get('alias') || '0';
			}
			// if (this.alias && this.campaign_id) {
			// 	this.getApprovee_Unreviewed_Leads();
			// }
		} else {
			this.route.params.subscribe((params) => {
				this.campaign_id = +params['id'];
				this.alias = params['alias'];
				// if (this.alias && this.campaign_id) {
				// 	this.getApprovee_Unreviewed_Leads();
				// }
				//this.loadCampaign();
			});
		}

		this.breadCrumbItems = [{ label: 'Apps' }, { label: 'Calendar', active: true }];

		this.formData = this.formBuilder.group({
			title: ['', [Validators.required]],
			category: ['', [Validators.required]],
		});

		const infoCacheKey = `campaign-info-${this.alias}-${this.campaign_id}`;
		const cachedInfo = this.calendarSrv.getCachedCampaignInfo(infoCacheKey);
		if (cachedInfo) {
			this.campaignInfo = cachedInfo;
			this.campaign_name = cachedInfo.name;
		} else {
			this.getInfoCalendar();
		}
		const from = this.route.snapshot.queryParamMap.get('from');
		if (from === 'campaign' && this.alias && this.campaign_id) {
			this.getApprovee_Unreviewed_Leads();
		}
	}

	calendarOptions: CalendarOptions = {
		plugins: [dayGridPlugin, timeGridPlugin],
		headerToolbar: {
			left: 'dayGridMonth,dayGridWeek,dayGridDay',
			center: 'title',
			right: 'prev,today,next',
		},
		initialView: 'dayGridMonth',
		weekends: true,
		editable: false,
		selectable: true,
		dayMaxEvents: true,

		eventClick: this.handleEventClick.bind(this),

		eventContent: (arg) => {
			const time = arg.timeText;
			const company = arg.event.extendedProps['company_name'] || '';
			return {
				html: `<b>${time}</b> | ${company}`,
			};
		},

		dayCellDidMount: (arg) => {
			const dateKey = dayjs(arg.date).format('YYYY-MM-DD');
			const count = this.eventCountByDate[dateKey] || 0;

			if (count > 0) {
				const badge = document.createElement('div');
				badge.className = 'day-event-counter';
				badge.textContent = String(count);
				arg.el.querySelector('.fc-daygrid-day-top')?.appendChild(badge);
			}
		},
	};

	currentEvents: EventApi[] = [];

	openModal(event?: any) {
		this.newEventDate = event;
		this.modalService.open(this.modalShow, { centered: true });
	}

	changeToDayView(date: string) {
		const selectedDate = dayjs(date).toDate();
		if (this.calendarComponent) {
			const calendarApi = this.calendarComponent.getApi();
			calendarApi.gotoDate(selectedDate);
			calendarApi.changeView('dayGridDay');
		}
	}


	openLead(lead_id: any) {
		const alias = this.route.snapshot.params['alias'];
		const id = this.route.snapshot.params['id'];

		this.router.navigate(['/lead', lead_id], {
			queryParams: {
				from: 'calendar',
				calendarAlias: alias,
				calendarId: id,
			},
		});
	}

	handleEventClick(clickInfo: any) {
		const lead_id = clickInfo.event.extendedProps.id;
		this.openLead(lead_id);
	}

	handleDateClick(clickInfo: any) {
		this.changeToDayView(clickInfo.dateStr);
	}

	handleEvents(events: EventApi[]) {
		this.currentEvents = events;
	}

	closeEventModal() {
		this.formData = this.formBuilder.group({
			title: '',
			category: '',
		});
		this.modalService.dismissAll();
	}

	position() {
		Swal.fire({
			position: 'center',
			icon: 'success',
			title: 'Event has been saved',
			showConfirmButton: false,
			timer: 1000,
		});
	}

	Editposition() {
		Swal.fire({
			position: 'center',
			icon: 'success',
			title: 'Event has been Updated',
			showConfirmButton: false,
			timer: 1000,
		});
	}

	get form() {
		return this.formData.controls;
	}

	saveEvent() {
		if (this.formData.valid) {
			const title = this.formData.get('title')!.value;
			const className = this.formData.get('category')!.value;
			const calendarApi = this.newEventDate.view.calendar;
			calendarApi.addEvent({
				id: createEventId(),
				title,
				start: this.newEventDate.date,
				end: this.newEventDate.date,
				className: className + ' ' + 'text-white',
			});
			this.position();
			this.formData = this.formBuilder.group({
				title: '',
				category: '',
			});
			this.modalService.dismissAll();
		}
		this.submitted = true;
	}

	editEventSave() {
		const editTitle = this.formEditData.get('editTitle')!.value;
		const editCategory = this.formEditData.get('editCategory')!.value;

		const editId = this.calendarEvents.findIndex((x) => x.id + '' === this.editEvent.id + '');

		this.editEvent.setProp('title', editTitle);
		this.editEvent.setProp('classNames', editCategory);

		this.calendarEvents[editId] = {
			...this.editEvent,
			title: editTitle,
			id: this.editEvent.id,
			classNames: editCategory,
		};
		this.Editposition();
		this.formEditData = this.formBuilder.group({
			editTitle: '',
			editCategory: '',
		});
		this.modalService.dismissAll();
	}

	confirm() {
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#34c38f',
			cancelButtonColor: '#f46a6a',
			confirmButtonText: 'Yes, delete it!',
		}).then((result) => {
			if (result.value) {
				this.deleteEventData();
				Swal.fire('Deleted!', 'Event has been deleted.', 'success');
			}
		});
	}

	deleteEventData() {
		this.editEvent.remove();
		this.modalService.dismissAll();
	}

	getMonthLeads() {
		const payload = {
			campaign_id: this.campaign_id,
			current_date: dayjs().format('YYYY-01-DD'),
		};
		this.calendarSrv.getCampaignMonthLeads(payload).subscribe((res: any) => {
			this.calendarEvents = this.transformLeadsToEvents(res.body.res);
			this.campaign_name = res.body.campaign_name;
			this.getBlackOutDays(this.campaign_id);

			this.calendarOptions = { ...this.calendarOptions, events: this.calendarEvents };
			//this.calendarComponent.getApi().refetchEvents();
			if (this.calendarComponent) {
				const calendarApi = this.calendarComponent.getApi();
				calendarApi.refetchEvents();
			}
		});
	}

	transformLeadsToEvents(leads: any[]): any[] {
		return leads.map((lead) => ({
			id: createEventId(),
			title: lead.prospect_name,
			start: dayjs(`${lead.start_date} ${lead.start_time}`).toDate(),
			end: dayjs(`${lead.end_date} ${lead.end_time}`).toDate(),
			allDay: false,
			className: lead.status === 1 ? 'bg-soft-primary' : 'bg-soft-success',
			metadata: { lead_id: lead.lead_id },
		}));
	}

	getBlackOutDays(campaign_id: number) {
		this.bodSrv.getCampaignBlackOutDays(campaign_id).subscribe((data: any) => {
			let bods = data.body;

			bods = bods.map((bod) => ({
				id: createEventId(),
				title: `${dayjs(bod.initial_date_hour, 'YYYY-MM-DD HH:mm:ss').format('h:mm A')} - ${dayjs(bod.end_date_hour, 'YYYY-MM-DD HH:mm:ss').format('h:mm A')}`,
				start: new Date(bod.initial_date_hour),
				end: new Date(bod.end_date_hour),
				allDay: false,
				className: 'bg-soft-danger',
				metadata: { bod: true, name: 'Black Out Day' },
			}));

			this.calendarEvents = this.calendarEvents.concat(bods);

			this.calendarOptions = { ...this.calendarOptions, events: this.calendarEvents };
			if (this.calendarComponent) {
				const calendarApi = this.calendarComponent.getApi();
				calendarApi.refetchEvents();
			}
		});
	}

	getInfoCalendar() {
		this.campaignSrv.getCampaignInfoCalendar(this.campaign_id).subscribe((data: any) => {
			this.campaignInfo = data.body;

			this.campaign_name = data.body.name;
			this.campaignInfo.script = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.script);
			this.campaignInfo.who_we_are = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.who_we_are);
			this.campaignInfo.what_we_do = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.what_we_do);
			this.campaignInfo.why_us = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.why_us);

			this.calendarSrv.setCachedCampaignInfo(`campaign-info-${this.alias}-${this.campaign_id}`, this.campaignInfo);
		});
	}

	showCalendarInfo() {}

	getApprovee_Unreviewed_Leads() {
		this.campaignLoading = true;

		this.calendarSrv.getApprovedUnreviewedLeads(this.alias, this.campaign_id).subscribe((data: any) => {
			if (!data?.success) {
				this.campaignMsg = 'FAIL: This campaign is not available.';
				this.campaignLoading = false;
				return;
			}

			const eventos = (data.body || []).map((event) => {
				const startDate = new Date(event.date_generated);
				const endDate = new Date(startDate);
				endDate.setHours(endDate.getHours() + 2);

				const isUnreviewed = event.lead_status === 'Unreviewed';

				return {
					start: startDate,
					end: endDate,
					title: `${event.first_name} ${event.last_name}`,
					allDay: false,
					//className: event.lead_status === 'Unreviewed' ? 'bg-soft-secondary' : 'bg-soft-success',

					display: 'block',
					backgroundColor: isUnreviewed ? '#e9ecef' : '#198754',
					borderColor: isUnreviewed ? '#ced4da' : '#146c43',
					textColor: '#ffffff',

					extendedProps: {
						id: event.id,
						name: `${event.first_name} ${event.last_name}`,
						company_name: event.company_name?.substring(0, 15),
						lead_status: event.lead_status,
					},
				};
			});

			this.calendarEvents = eventos;

			this.eventCountByDate = {};

			eventos.forEach((event) => {
				const dateKey = dayjs(event.start).format('YYYY-MM-DD');
				this.eventCountByDate[dateKey] = (this.eventCountByDate[dateKey] || 0) + 1;
			});

			this.calendarOptions = {
				...this.calendarOptions,
				events: this.calendarEvents,
			};

			setTimeout(() => {
				if (this.calendarComponent) {
					const api = this.calendarComponent.getApi();
					const currentView = api.view.type;
					api.changeView('dayGridWeek');
					api.changeView(currentView);
				}
			}, 0);

			this.getBlackOutDays(this.campaign_id);
			this.campaignLoading = false;
		});
	}
	ngAfterViewInit(): void {
		if (this.calendarComponent) {
			const api = this.calendarComponent.getApi();
		}
	}
}
